import { isPermissionEnabled } from "./permissionStorage";

function on(permissions, key) {
  return isPermissionEnabled(permissions?.[key]);
}

/** Legacy combined flag still grants both until roles are reconfigured. */
function legacyDeleteExport(permissions) {
  return on(permissions, "can_delete");
}

export function canExportData(permissions) {
  return on(permissions, "can_export_data") || legacyDeleteExport(permissions);
}

export function canArchiveRecord(permissions) {
  return on(permissions, "can_archive_record") || legacyDeleteExport(permissions);
}

export function canRestoreArchivedRecord(permissions) {
  return (
    on(permissions, "can_restore_archived_record") || legacyDeleteExport(permissions)
  );
}

export function canDeleteOwnDraft(permissions) {
  return on(permissions, "can_delete_own_draft") || legacyDeleteExport(permissions);
}

export function canDeleteDepartmentDraft(permissions) {
  return (
    on(permissions, "can_delete_department_draft") || legacyDeleteExport(permissions)
  );
}

export function canPermanentlyDeleteRecord(permissions) {
  return on(permissions, "can_permanently_delete_record");
}

/** Row delete / destructive actions (not export). */
export function canDeleteRecords(permissions) {
  return (
    canDeleteOwnDraft(permissions) ||
    canDeleteDepartmentDraft(permissions) ||
    canPermanentlyDeleteRecord(permissions) ||
    legacyDeleteExport(permissions)
  );
}
